import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';

import useTrialModal from 'hooks/use-trial-modal';
import { useAiInsightsCounter } from 'queries/bulletins/use-ai-insights-counter';
import { useUserInfo } from 'queries/user-action/use-user-info';

import ChevronUpDoubleIcon from '../../assets/chevron-up-double.svg';
import StarsIcon from '../../assets/stars.svg';
import BaseLauncher from '../BaseLauncher';
import LauncherButton from '../LauncherButton';

interface Props {
    onLaunch?: () => void;
    className?: string;
}

const AuthorizedUnpaidView: React.FC<Props> = ({ className, onLaunch }) => {
    const trial = useTrialModal();
    const { data } = useAiInsightsCounter();
    const { data: hasActiveTrial } = useUserInfo({
        select: (data) =>
            data ? data.licenses.some(({ isValid, licenseType }) => isValid && /trial/i.test(licenseType)) : false
    });

    if (!data) {
        return null;
    }

    return (
        <BaseLauncher
            title={
                data.limit === null ? (
                    <>
                        {'Introducing'}
                        &nbsp;
                        <strong>{'AI Insights.'}</strong>
                        &nbsp;
                        {'instantly decode any CVE'}
                    </>
                ) : (
                    <>
                        <strong>{`${Math.max(data.limit - data.count, 0)} of ${data.limit}`}</strong>
                        &nbsp;
                        {'AI Insights are available for you today'}
                    </>
                )
            }
            description={'Leverage the power of AI to quickly understand vulnerabilities, impacts, and exploitability'}
            action={
                data.limit === null || data.count < data.limit ? (
                    <LauncherButton startIcon={<StarsIcon />} onClick={onLaunch}>
                        {'Get AI Insights for that CVE'}
                    </LauncherButton>
                ) : hasActiveTrial ? (
                    <LauncherButton startIcon={<ChevronUpDoubleIcon />} component={Link} to={'/company/contacts'}>
                        {'Upgrade plan'}
                    </LauncherButton>
                ) : (
                    <>
                        <LauncherButton startIcon={<ChevronUpDoubleIcon />} onClick={trial.onAnchorClick}>
                            {'Start 30-day trial'}
                        </LauncherButton>
                        {trial.modal}
                    </>
                )
            }
            className={className}
        />
    );
};

export default observer(AuthorizedUnpaidView);
